import React from "react";
import { userData } from "../../Components/User";
import { Box, Button, Skeleton, Typography } from "@mui/material";
import {
  ExitToApp,
} from "@mui/icons-material";
import AccountMenu from "../AccountMenu";

const Header = () => (
  <Typography
    variant="h1"
    sx={{
      color: 'text.primary',
      fontWeight: 'bold',
      fontSize: 33,
      marginTop: 4,
      marginLeft: 4,
    }}>
      <Box sx={{
        borderBottom: '2px solid #FCD037',
        padding: 1,
        borderWidth: 2,
        display: 'inline-block',
      }}>
        Painel Etapa Digital
      </Box>
  </Typography>
);

const Acessar = ({ url, token }: { url: string, token: any }) => (
  <div>
    <Typography
      variant="subtitle1"
      sx={{
        color: 'text.primary',
        fontSize: 14,
        marginLeft: 4,
      }}>
      Tenha acesso às suas apostilas de forma rápida e fácil.
    </Typography>
    <Button
      variant="contained"
      sx={{
        backgroundColor: '#142878',
        color: '#FCD037',
        fontSize: 12,
        fontWeight: 'bold',
        marginTop: 2,
        marginLeft: 4,
      }}
      disabled={!token}
      onClick={() => {
        if (token) window.open(url + token, '_blank');
      }}>
        <ExitToApp sx={{ marginRight: 1, fontSize: 20 }} />
        Acessar Material
    </Button>
  </div>
);

const EtapaDigitalColegio = () => {
  const { user } = userData();
  const sso_url = "https://material.etapadigital.com.br/sso?jwt=";

  return (
    <Box sx={{ flex: 1 }}>
      <AccountMenu />
      <Header />

      <Box sx={{ width: '100%', display: 'flex', justifyContent: 'center', marginTop: 4 }}>
        <Box sx={{
          width: '90%',
          marginTop: 2,
          border: '1px solid #FCD037',
          padding: 2,
        }}>

          {!user.tokenB2C ? (
            <Typography
              variant="subtitle1"
              sx={{
                color: '#663D0C',
                fontSize: 14,
                marginLeft: 4,
              }}>
                Sem acesso ao <strong>Etapa Digital</strong>. Procure a secretaria do colégio.
            </Typography>
            ): (
              <Acessar url={sso_url} token={user.tokenB2C} />
          )}

        </Box>
      </Box>
    </Box>
  );
}
export default EtapaDigitalColegio;